import { render, staticRenderFns } from "./FacturesAdminView.vue?vue&type=template&id=5cd0c7b0"
import script from "./FacturesAdminView.vue?vue&type=script&lang=js"
export * from "./FacturesAdminView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports